// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3wBaq","footer":"ModalCreateQualiphyProcedure_footer__Kb_NJ","additionData":"ModalCreateQualiphyProcedure_additionData__2fD-3"};